
import Vue from "vue";
import sourcePreview from "components/SourcePreview.vue";
import {
  GetSourceList,
  GetSourceInfo,
  GetPartnerSource,
  GetSchoolSource
} from "api/v1.design.courseware";
import { saveCourseProcessCellDoc } from "api/v1.faceteachactivity";
import { Message } from "element-ui";
import PreparingCourseware from "components/PreparingCourseware.vue";
import SourceListToSchool from "components/SourceListToSchool.vue";
import SourceListToPartner from "components/SourceListToPartner.vue";

export default Vue.extend({
  components: {
    SourceListToSchool: SourceListToSchool,
    SourceListToPartner: SourceListToPartner,
    "source-preview": sourcePreview,
    PreparingCourseware
  },
  data() {
    return {
      radio:"",
      files: [],
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: <any>[],
      nodePathList: <any>[],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      dataCount: 1,
      folderId: "",
      sourceIds: <any>[],
      checkedList: <any>[],
      sourceId: "",
      checks: <any>[],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      disabled: false,
      checkStatus: false,
      checkArr: <any>[],
      dialogVisiblePreviewResources: false,
      activeName: "source",
      IsScourseList: true
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    topicId:{
      type: String,
      default: ""
    },
    cellLevel:{
      type: String,
      default: ""
    },
    cellId:{
      type: String,
      default: ""
    },
    parentId:{
      type: String,
      default: ""
    },
    cellName:{
      type: String,
      default: ""
    },
    cellContent:{
      type: String,
      default: ""
    },
    maxSortOrder:{
      type: Number,
      default: 0
    },
    activityIds: {},
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    createIn: {
      type: Number,
      default: 0
    },
    faceTeachState: {
      default: ""
    },
    // checkData: {
    //   type: String,
    //   default: ""
    // }
  },
  created() {
    this.getSourceList("source", 1);
  },
  watch: {
  },
  methods: {
    
    handleClick(event: any) {
      debugger;
      this.activeName = event.name;
      this.list = <any>[];
      this.totalCount = 0;
      this.pageSize = 8;
      this.courseName = "";
      this.nodePathList = [];
      this.dataCount = 1;
      this.folderId = "0";
      if (this.activeName == "source") {
        this.getSourceList("source", 1);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        this.IsScourseList = false;
        // this.getPartnerSource(1);
      } else if (this.activeName == "school") {
        // this.getSchoolSource(1);
        this.IsScourseList = false;
      }
    },
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    getSourceList(type: string, page: any) {
      this.$nextTick(() => {
        GetSourceList(this.courseId, this.folderId, type, page).then(rst => {
          debugger;
          this.list = rst.list;
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.courseName = rst.courseName;
          this.nodePathList = rst.nodePathList;
          this.dataCount = rst.dataCount;
          console.log(this.list);
          rst.list.forEach(item => {
            this.$set(this.checkedList, item.Id, false);
          });
        });
      });
    },
    getPartnerSource(page: any) {
      this.$nextTick(() => {
        GetPartnerSource(this.folderId, page).then(rst => {
          this.list = rst.list;
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.courseName = rst.courseName;
          this.nodePathList = rst.nodePathList;
          this.dataCount = rst.dataCount;
          console.log(this.list);
          rst.list.forEach(item => {
            this.$set(this.checkedList, item.Id, false);
          });
        });
      });
    },
    getSchoolSource(page: any) {
      this.$nextTick(() => {
        GetSchoolSource(this.folderId, page).then(rst => {
          this.list = rst.list;
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.courseName = rst.courseName;
          this.nodePathList = rst.nodePathList;
          this.dataCount = rst.dataCount;
          console.log(this.list);
          rst.list.forEach(item => {
            this.$set(this.checkedList, item.Id, false);
          });
        });
      });
    },
    clickFolderHander(newFolderId: any) {
      this.folderId = newFolderId;
      let pageIndex = this.list.pageIndex;
      if (this.activeName == "source") {
        this.getSourceList("source", pageIndex);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        // this.getPartnerSource(pageIndex);
        this.IsScourseList = false;
      } else if (this.activeName == "school") {
        // this.getSchoolSource(pageIndex);
        this.IsScourseList = false;
      }
    },
    previewImage(Id: string, url: string, type: string) {
      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }
        GetSourceInfo(Id).then(rst => {
          console.log(rst);
          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            this.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };
          }
        });
      }
    },
    onPageChangeHandler(page: number) {
      if (this.activeName == "source") {
        this.getSourceList("source", page);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        // this.getPartnerSource(page);
        this.IsScourseList = false;
      } else if (this.activeName == "school") {
        // this.getSchoolSource(page);
        this.IsScourseList = false;
      }
    },
    handleSelectionChange(Id: any) {
      debugger;
      this.radio;
      // this.checkedList[0] = Id;
      // if (!this.checkedList[Id]) {
      //   this.checkedList[Id] = false;
      //   var index = this.sourceIds.indexOf(Id);
      //   this.sourceIds.splice(index, 1);
      // } else {
      //   this.checkedList[Id] = true;
      //   this.sourceIds.push(Id);
      // }
      this.sourceIds = this.radio;
      console.log(this.sourceIds);
      this.$emit('onClickId',this.sourceIds);
    },
    handleSelectionClick(Id: any,check:any){
      if (check==true) {
       this.radio="";
      } else {
        // this.sourceIds.push(Id);
        this.radio=Id;
      }
      console.log(this.radio);
      this.$emit('onClickId',this.radio);
    },
    importSource() {
      if (this.sourceIds.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        saveCourseProcessCellDoc(
          this.courseId,
          this.topicId,
          this.parentId,
          this.maxSortOrder,
          this.sourceIds,
        ).then(rst => {
          if (rst.code > 0) {
            debugger;
            var list = rst.cellList;
            this.$message.success(rst.msg);
          } else {
            this.$message({
              type: "warning",
              message: rst.msg
            });
          }

          let checkLength = this.list.length;
          for (let i = 0; i < checkLength; i++) {
            if (this.list[i].checked) {
              if (this.list[i].checked == true) {
                this.list[i].checked = false;
              }
            }
          }
          this.sourceIds = [];
          this.$emit("closeDialog", true,list);
        });
      }
      this.disabled = false;
      this.checkStatus = true;
    }
  }
});
